import { gql } from '@apollo/client';

export default gql`
  query impulseUpgradeJourneySearch($exchangeItems: [Int!], $reference: String!, $currency: String!) {
    impulseUpgradeJourneySearch(exchangeItems: $exchangeItems, reference: $reference, currency: $currency) {
      outbound {
        ...exchangeOffer
      }
      inbound {
        ...exchangeOffer
      }
      passengers {
        id
        disabilityType
        type
      }
    }
  }

  fragment exchangeOffer on Offer {
    journeys {
      fares {
        productCode
        legs {
          timing {
            departureDate
            departs
            arrives
            duration
          }
          products {
            passengerId
            tariffCode
            price
          }
        }
        fees {
          tariffCode
          price
          name
          passengerId
          code
        }
        productFamily {
          code
          name
          familyGroup
        }
        classOfService {
          code
          name
        }
        prices {
          displayPrice
        }
        bookingItems {
          passengerId
          tariffCode
          price
        }
      }
    }
  }
`;
